import MojitoModules from 'mojito/modules';

import {isLightColor} from '#core/utils/color-utils.js';

import {avantgardeFallbackCardsFactory} from './factory/avantgarde-fallback-cards.factory.js';
import {avantgardeMatchCardsFactory} from './factory/avantgarde-match-cards.factory.js';
import {avantgardeOutrightCardsFactory} from './factory/avantgarde-outright-cards.factory.js';
import {avantgardeSelectionCardsFactory} from './factory/avantgarde-selection-cards.factory.js';
const {COLOR_MODES} = MojitoModules.EventCards.types;

export function avantgardeEventCardsFactory(PALETTE) {
    const COLOR_MODE = isLightColor(PALETTE.PARENT.CARD_CONTAINER_BG, true) ? COLOR_MODES.LIGHT : COLOR_MODES.DARK;

    return {
        ...avantgardeMatchCardsFactory(PALETTE, COLOR_MODE),
        ...avantgardeOutrightCardsFactory(PALETTE, COLOR_MODE),
        ...avantgardeSelectionCardsFactory(PALETTE, COLOR_MODE),
        ...avantgardeFallbackCardsFactory(PALETTE),
    };
}
